import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Step1 from "./views/Step1.vue";
import NewStep2 from "./views/new-customer/Step2.vue";
import KnownStep2 from "./views/known-customer/Step2.vue";
import Visitor from "./views/Visitor.vue";
import Loser from "./views/Loser.vue";
import Winner from "./views/Winner.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/step-1",
            name: "step-1",
            component: Step1
        },
        {
            path: "/new/step-2",
            name: "new-step-2",
            component: NewStep2
        },
        {
            path: "/known/step-2",
            name: "known-step-2",
            component: KnownStep2
        },
        {
            path: "/visitor",
            name: "visitor",
            component: Visitor
        },
        {
            path: "/loser",
            name: "loser",
            component: Loser
        },
        {
            path: "/winner",
            name: "winner",
            component: Winner
        }
    ]
});
